






































































































































































































































































































































// 接口和其他
import { getSelectClassList, getSeleSubjectsList } from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { eduDataApi, eduDataInter } from "@/api/statistics";
import { Vue, Component } from "vue-property-decorator";
import {
  dateFormat,
  getCurrentMonth,
  getLatestMonth,
} from "@/utils/timeFormat";
import pushSettingDialog from "./pushSettingDialog.vue";
import comprehensiveData from "./comprehensiveData.vue";
import educational from "./educational.vue";
import teachingTeacher from "./teachingTeacher.vue";
import classroom from "./class.vue";
import subject from "./subject.vue";
import { roundNumbers } from "@/utils/roundNumbers";
@Component({
  name: "statisticsEducational",
  components: {
    pushSettingDialog,
    comprehensiveData,
    educational,
    teachingTeacher,
    classroom,
    subject,
    commonStaffPullDown,
  },
})
export default class extends Vue {
  searchInfo: any = {
    date: [],
    range: "month",
    teacher_id: "" as number | string,
    course_type: -1,
    day_week_month: 1,
    showRegionTab: false, // 是否开启高级筛选,只显示综合数据
  };
  searchData: any = {}; // 高级搜索;
  currentTimeRange: string[] = [];
  update: boolean = false; // 通知子组件更新列表数据
  get currentTimeRangeLength() {
    if (this.currentTimeRange.length === 2) {
      const dec =
        this.newDate(this.currentTimeRange[1]).getTime() -
        this.newDate(this.currentTimeRange[0]).getTime();
      return dec / (24 * 60 * 60 * 1000);
    } else {
      return 0;
    }
  }
  currentDataType: string = "real_consume_number";
  chartDataCache: any = {};
  totalData: any = {};
  allTableData: any[] = [];
  myChart: any = {};
  exporting: boolean = false;
  resizeMark = false;
  current_teacher = {
    teacher_name: "",
    teacher_id: 0,
  };
  classList: any[] = []; //班级列表
  subjectsList: any[] = []; //班级列表
  comprehensiveData: any[] = [];
  checkTabs: number = 1;
  weekTime: any = []; // 按周查询
  monthTime: any = []; // 按月查询
  weekStartTimeNum: number = 0; // 查询时间周开始
  endTimeNum: number = 0; // 查询时间周结束
  newDate(time: any) {
    if (typeof time === "string") {
      return new Date(time.replace(/-/g, "/"));
    } else {
      return new Date(time);
    }
  }
  created() {
    getSelectClassList({
      page: 1,
      page_size: 500,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.classList = res.data.list;
      }
    });
    getSeleSubjectsList({
      page: 1,
      page_size: 500,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.subjectsList = res.data.list;
      }
    });
  }
  mounted() {
    this.searchRangeChange(this.searchInfo.range, "");
    this.searchData = this.searchInfo;
  }
  handleChangeSelect() {}
  timestampToTime(timestamp: any) {
    const date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + "-";
    const M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  }
  // 数据获取
  getChartData() {
    const start = this.currentTimeRange[0];
    const end = this.currentTimeRange[1];
    const params: eduDataInter = {
      start_date: start,
      end_date: end,
    };
    if (this.searchInfo.eduStaff_id && this.searchInfo.region === 1) {
      params.edu_teacher_id = this.searchInfo.eduStaff_id;
    }
    if (this.searchInfo.teachStaff_id && this.searchInfo.region === 2) {
      params.teacher_id = this.searchInfo.teachStaff_id;
    }
    if (this.searchInfo.class_id && this.searchInfo.region === 3) {
      params.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.subject_id && this.searchInfo.region === 4) {
      params.subject_id = this.searchInfo.subject_id;
    }
    if (this.searchInfo.day_week_month === 1) {
      if (this.searchInfo.dayStart) {
        if (this.searchInfo.dayEnd) {
          params.start_date = this.searchInfo.dayStart;
          params.end_date = this.searchInfo.dayEnd;
        }
      }
    } else if (this.searchInfo.day_week_month === 2) {
      if (this.weekTime.length === 2) {
        params.start_date = this.weekTime[0];
        params.end_date = this.weekTime[1];
      }
    } else if (this.searchInfo.day_week_month === 3) {
      if (this.monthTime.length === 2) {
        params.start_date = this.monthTime[0];
        params.end_date = this.monthTime[1];
      }
    }
    this.currentTimeRange[0] = params.start_date;
    this.currentTimeRange[1] = params.end_date;
    eduDataApi(params).then((res: any) => {
      if (res.error_code === 0) {
        this.comprehensiveData = [];
        // 没有高级筛选
        if (!this.searchInfo.region) {
          const studentArr: any = {
            title: "出勤数据",
            popover1:
              "在读学员: 所选时间最后一刻的在读学员数,仅支持查看2023年7月份后数据",
            popover2:
              "出勤率: 根据已点名课次中的学员数计算，出勤率 = 点名实到学员 / 已点应到学员 * 100%",
            popover3:
              "1vN满班率: 1vN满班率 = 1vN耗课人次和 / 1vN耗课班级预设容量和 * 100%",
            n: 1,
            arr: [
              {
                name: "在读学员",
                num: res.data.on_going_num,
                route_name: "",
                key: "",
              },
              {
                name: "出勤率",
                num: roundNumbers(res.data.attendance_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "1vN满班率",
                num: roundNumbers(res.data.otm_sufficient_class_rate) + "%",
                route_name: "",
                key: "",
              },
            ],
          };
          const stageArr: any = {
            title: "点名数据",
            popover4: "点名课次: 所选时间段内，教师的点名课次数之和",
            popover5: "点名实到学员: 已点名课次中，实际到班上课的学员",
            // popover6: "点名未到学员: 已点名课次中，没有到班上课的学员",
            // popover7: "点名正课学员: 已点名课次中，所有正课学员",
            popover8: "点名补课学员: 已点名课次中，所有补课学员",
            // popover9: "点名体验学员: 已点名课次中，所有体验学员",
            popover10: "点名应到学员: 已点名课次中，排课的学员数之和",
            n: 2,
            arr: [
              {
                name: "点名课次",
                num: res.data.roll_call_lesson_num,
                route_name: "",
                key: 1,
              },
              {
                name: "点名实到学员",
                num: res.data.roll_call_attend_student_num,
                route_name: "",
                key: 3,
              },
              // {
              //   name: "点名未到学员",
              //   num: res.data.roll_call_absent_student_num,
              //   route_name: "",
              //   key: 4,
              // },
              // {
              //   name: "点名正课学员",
              //   num: res.data.roll_call_normal_student_num,
              //   route_name: "",
              //   key: 6,
              // },
              {
                name: "点名补课学员",
                num: res.data.roll_call_make_up_student_num,
                route_name: "",
                key: "",
              },
              // {
              //   name: "点名体验学员",
              //   num: res.data.roll_call_experience_student_num,
              //   route_name: "",
              //   key: "",
              // },
              {
                name: "点名应到学员",
                num: res.data.roll_call_should_attend_student_num,
                route_name: "",
                key: "",
              },
            ],
          };
          const transformArr = {
            title: "课消数据",
            popover11: "耗课数: 所有已点名应到学员消耗的课时数，不含超上学员",
            popover12: "1vN耗课数: 所有1vN班级消耗的课时数，不含超上课时员",
            popover13: "1v1耗课数: 所有1v1班级消耗的课时数，不含超上课时",
            popover14:
              "课消金额: 所有已点名应到学员消耗的课时金额，不含超上学员",
            popover15: "1vN课消金额: 所有1vN班级消耗的课时金额，不含超上",
            popover16: "1v1课消金额: 所有1v1班级消耗的课时金额，不含超上",
            n: 3,
            arr: [
              {
                name: "耗课数",
                num: roundNumbers(res.data.real_consume_num),
                route_name: "",
                key: "",
              },
              {
                name: "1vN耗课数",
                num: roundNumbers(res.data.otm_real_consume_num),
                route_name: "",
                key: "",
              },
              {
                name: "1v1耗课数",
                num: roundNumbers(res.data.oto_real_consume_num),
                route_name: "",
                key: "",
              },
              {
                name: "课消金额",
                num: roundNumbers(res.data.consume_amount),
                route_name: "",
                key: "",
              },
              {
                name: "1vN课消金额",
                num: roundNumbers(res.data.otm_consume_amount),
                route_name: "",
                key: "",
              },
              {
                name: "1v1课消金额",
                num: roundNumbers(res.data.oto_consume_amount),
                route_name: "",
                key: "",
              },
            ],
          };
          this.comprehensiveData.push(studentArr, stageArr, transformArr);
        } else {
          // 高级筛选
          let searchTitle = "";
          if (this.searchInfo.region === 1) {
            searchTitle = "教务数据";
          } else if (this.searchInfo.region === 2) {
            searchTitle = "教师数据";
          } else if (this.searchInfo.region === 3) {
            searchTitle = "班级数据";
          } else if (this.searchInfo.region === 4) {
            searchTitle = "科目数据";
          }
          const regionList: any = {
            title: searchTitle,
            popover17:
              "出勤率: 根据已点名课次中的学员数计算，出勤率 = 点名实到学员 / 已点应到学员 * 100%",
            popover18: "点名课次: 所选时间段内，教师的点名课次数之和",
            popover19: "耗课数: 所有已点名应到学员消耗的课时数，不含超上学员",
            popover20:
              "课消金额: 所有已点名应到学员消耗的课时金额，不含超上学员",
            n: 4,
            arr: [
              {
                name: "出勤率",
                num: roundNumbers(res.data.attendance_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "点名课次",
                num: res.data.roll_call_lesson_num,
                route_name: "",
                key: "",
              },
              {
                name: "耗课数",
                num: roundNumbers(res.data.real_consume_num),
                route_name: "",
                key: "",
              },
              {
                name: "课消金额",
                num: roundNumbers(res.data.consume_amount),
                route_name: "",
                key: "",
              },
            ],
          };
          this.comprehensiveData.push(regionList);
        }
      }
    });
  }
  // 搜索交互
  handleTime(val: any) {
    this.searchInfo.range = "free";
    // 处理周时间选择范围
    if (this.searchInfo.day_week_month === 2) {
      if (this.searchInfo.weekStart) {
        const todayDay = this.searchInfo.weekStart
          ? new Date(this.searchInfo.weekStart)
          : new Date();
        const todayOfWeek = todayDay.getDay();
        let spendDay = 1;
        if (todayOfWeek !== 0) {
          spendDay = 7 - todayOfWeek; // 开始时间到结束时间还有几天
        }
        this.weekStartTimeNum = todayDay.valueOf() - (6 - spendDay) * 86400000; // 开始时间时间戳
        const startTimeStr = this.timestampToTime(this.weekStartTimeNum); // 时间戳转字符串
        this.weekTime[0] = startTimeStr;
        if (this.searchInfo.weekEnd) {
          const todayDay = this.searchInfo.weekEnd
            ? new Date(this.searchInfo.weekEnd)
            : new Date();
          const todayOfWeek = todayDay.getDay();
          let spendDay = 1;
          if (todayOfWeek !== 0) {
            spendDay = 7 - todayOfWeek; // 开始时间到结束时间还有几天
          }
          this.endTimeNum = todayDay.valueOf() + spendDay * 86400000; // 结束时间时间戳
          const endTimeStr = this.timestampToTime(this.endTimeNum);
          this.weekTime[1] = endTimeStr;
        }
      }
      if (!this.searchInfo.weekStart && !this.searchInfo.weekEnd) {
        this.weekTime = [];
        this.searchRangeChange("month");
      }
    }
    // 处理周时间选择范围
    if (this.searchInfo.day_week_month === 3) {
      if (this.searchInfo.monthStart) {
        this.monthTime[0] = this.searchInfo.monthStart;
      }
      if (this.searchInfo.monthEnd) {
        const newArr = getCurrentMonth(this.searchInfo.monthEnd);
        this.monthTime[1] = dateFormat("YYYY-mm-dd", newArr[1]);
      }
      if (!this.searchInfo.monthStart && !this.searchInfo.monthEnd) {
        this.monthTime = [];
        this.searchRangeChange("month");
      }
    }
    if (!this.searchInfo.dayStart && !this.searchInfo.dayEnd) {
      this.searchRangeChange("month");
    }
    this.getChartData();
    this.update = !this.update;
  }
  searchRangeChange(type: string, val?: string) {
    let start: string = "";
    let end: string = "";
    const now = new Date();
    if (val === "del") {
      delete this.searchInfo.dayStart;
      delete this.searchInfo.dayEnd;
      delete this.searchInfo.weekStart;
      delete this.searchInfo.weekEnd;
      delete this.searchInfo.monthStart;
      delete this.searchInfo.monthEnd;
      this.weekTime = [];
      this.monthTime = [];
    }
    switch (type) {
      case "month":
        const monthArr = getCurrentMonth(now);
        start = dateFormat("YYYY-mm-dd", monthArr[0]);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "last_month":
        const d = now.getDate();
        const lastMonthArr = getCurrentMonth(
          now.getTime() - d * 24 * 60 * 60 * 1000
        );
        start = dateFormat("YYYY-mm-dd", lastMonthArr[0]);
        end = dateFormat("YYYY-mm-dd", lastMonthArr[1]);
        break;
      case "three_month":
        start = getLatestMonth(3);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "six_month":
        start = getLatestMonth(6);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "twelve_month":
        start = getLatestMonth(12);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "twenty_four_month":
        start = getLatestMonth(24);
        end = dateFormat("YYYY-mm-dd", now);
        break;
    }
    this.currentTimeRange = [start, end];
    this.searchInfo.range = type;
    this.searchInfo.date = [];
    this.getChartData();
  }
  handleSearch(v: any) {
    if (this.searchInfo.region) {
      this.searchInfo.showRegionTab = true;
      this.checkTabs = 1;
    } else {
      this.searchInfo.showRegionTab = false;
    }
    this.searchData = this.searchInfo;
    this.getChartData();
  }
}
